import Vue from 'vue'
import colors from 'vuetify/es5/util/colors'

import {
	Ripple,
	Resize,
	Scroll,
} from 'vuetify/es5/directives';

import {
	Vuetify,
	VApp,
	VAlert,
	VGrid,
	VNavigationDrawer,
	VToolbar,
	VFooter,
	VSubheader,
	VMenu,
	VList,
	VBtn,
	VBtnToggle,
	VIcon,
	VTooltip,
	VBadge,
	VAvatar,
	VTextField,
	VTextarea,
	VTimePicker,
	VTabs,
	VSelect,
	VCheckbox,
	VRadioGroup,
	VSwitch,
	VChip,
	VDataIterator,
	VCard,
	VDivider,
	VDataTable,
	VAutocomplete,
	VImg,
	VHover,
	VDialog,
	VProgressCircular,
	VSnackbar
} from 'vuetify'


import VueDraggable from 'vue-draggable';
Vue.use(VueDraggable);

Vue.use(
	Vuetify,
	{
		components: {
			VApp,
			VAlert,
			VNavigationDrawer,
			VGrid,
			VToolbar,
			VFooter,
			VSubheader,
			VMenu,
			VList,
			VBtn,
			VBtnToggle,
			VIcon,
			VTooltip,
			VBadge,
			VAvatar,
			VTextField,
			VTextarea,
			VTimePicker,
			VTabs,
			VSelect,
			VCheckbox,
			VRadioGroup,
			VSwitch,
			VChip,
			VDataIterator,
			VCard,
			VDivider,
			VDataTable,
			VAutocomplete,
			VImg,
			VHover,
			VDialog,
			VProgressCircular,
			VSnackbar
		},
		directives: {
			Resize,
			Ripple,
			Scroll,
		},
		theme: {
			primary    : colors.blue.darken4,
			secondary  : colors.orange,
			accent     : colors.blue.darken4
		},
        noDataText        : 'No data available!!!!',

        dataIterator      : {
            noResultsText     : 'Woah'
        }
	}
)

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import vueResponsive from 'vue-responsive'
import { loadView, loadComponent } from '@/mixins/asyncLoaders'
import displayName from '@/mixins/filters/displayName'
import matchFilter from '@/mixins/filters/matchFilter'
import checkValidProp from '@/mixins/filters/checkValidProp'
import bytesToString from '@/mixins/filters/bytesToString'
import objectHash from '@/mixins/objectHash'
import regexTesters from '@/mixins/regexTesters'
import vuelidate from 'vuelidate'
import { twoDigitFullDate, twoDigitMonthDay, relativeDateCompact, hourMinute } from '@/mixins/filters/dateFormatters'
import { VUEX_APP_INIT } from '@/store/constants/app'
import '@/registerServiceWorker'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import UUID from 'vue-uuid'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)

//
// Use statements
//
Vue.use(vueResponsive)
Vue.use(Donut)
Vue.use(vuelidate)
Vue.use(UUID)


// Global Filters
//
Vue.filter('f__displayName', displayName)
Vue.filter('f__twoDigitFullDate', twoDigitFullDate)
Vue.filter('f__twoDigitMonthDay', twoDigitMonthDay)
Vue.filter('f__relativeDateCompact', relativeDateCompact)
Vue.filter('f__hourMinute', hourMinute)
Vue.filter('f__matchFilter', matchFilter)
Vue.filter('f__checkValidProp', checkValidProp)
Vue.filter('f__bytesToString', bytesToString)

//
// Global Mixins
//
Vue.mixin(objectHash)
Vue.mixin(regexTesters)


//
// Router sync
//
/* eslint-disable-next-line no-unused-vars */
const unsync = sync(store, router)


// TODO: Config this!
Vue.config.productionTip = false

//
// Set our token before we even get into the app, or everything goes crazy
//
let appInstance = null
store.dispatch(VUEX_APP_INIT).then(() => {
	appInstance = new Vue({
		router,
		store,
		methods: {
            loadView,
			loadComponent
		},
        watch: {
            "$route": () => {
                window.Appcues.page()
            }
        },
		render: h => h(App)
	}).$mount('#app')
})

export default appInstance
